interface Survey {
  id: number;
  // title: string;
  // subtitle: string;
  videoUrl: string;
  poster: string;
}

interface SurveyCardProps {
  survey: Survey;
}

function SurveyCard({ survey }: SurveyCardProps) {
  return (
    <div className="relative group">
      <video controls poster={survey.poster} className="w-full h-[390px] sm:h-[390px] md:h-[440px] lg:h-[490px]" style={{ aspectRatio: "16/9" }}>
        <source src={survey.videoUrl} type="video/mp4" />
        Ваш браузер не поддерживает воспроизведение видео.
      </video>
      {/* <div className="absolute bottom-4 left-4 text-white z-10">
        <p className="text-sm uppercase">{survey.subtitle}</p>
        <h3 className="text-lg font-semibold">{survey.title}</h3>
      </div> */}
    </div>
  );
}

export default SurveyCard;
